import React, { useEffect, useState } from "react";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAI_Co_ApplicantNamesData,
  restI_Co_ApplicantNamesDataValidate,
  ValidateAI_Co_ApplicantNames,
} from "../../../../Redux/Reducers/CoApplicantNames";
import InputAHSF from "../../../../Components/InputAHSF";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import { AddCoApplicantNames } from "../../../../Services/CoApplicantNames/AddCoApplicantNames";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import $ from "jquery";
import { UpdateCoApplicantNames } from "../../../../Services/CoApplicantNames/UpdateCoApplicantNames";
import AttachmentASFH from "../../../../Components/AttachmentsAHSF";
import loadConfig from "../../../../Services/apiService";
import axios from "axios";
import { PiNutDuotone } from "react-icons/pi";
import Swal from "sweetalert2";
const AddEdite_CoApplicantNames = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      dropDownApplicationInformation:
        state.dropDownApplicationInformation.SubSector,
      dropDownApplicationInformationLoding:
        state.dropDownApplicationInformation,
      SubSectors: state.SubSectors,
      AI_Co_ApplicantNamesData:
        state.AI_Co_ApplicantNamesData.AI_Co_ApplicantNamesData,
      loadingAI_Co_ApplicantNamesData:
        state.AI_Co_ApplicantNamesData.loadingAI_Co_ApplicantNamesData,
      BeneficiaryInformation:
        state.BeneficiaryInformation.BeneficiaryInformation,
      AI_Co_ApplicantNamesValidate:
        state.AI_Co_ApplicantNamesData.AI_Co_ApplicantNamesValidate,
      PersonalInformation: state.PersonalInformation.PersonalInformation,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [proofOfIdentityDocument, setproofOfIdentityDocument] = useState();
  const [fileChange, setFileChange] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);
  const [CoApplicantNamesData, setCoApplicantNamesData] = useState({
    aI_Co_applicantNamesId: null,
    //   state.AI_Co_ApplicantNamesData?.aI_Co_applicantNamesId,
    gender: null,
    //  state.AI_Co_ApplicantNamesData?.gender,
    phoneNumber: null,
    // state.AI_Co_ApplicantNamesData?.phoneNumber,
    emailAddress: null,
    //  state.AI_Co_ApplicantNamesData?.emailAddress,
    proofOfIdentityDocument: null,
    //   state.AI_Co_ApplicantNamesData?.proofOfIdentityDocument,
    commissioner: null,
    //  state.AI_Co_ApplicantNamesData?.commissioner,
    fourSyllablesName: null,
    //  state.AI_Co_ApplicantNamesData?.fourSyllablesName,
    aI_BeneficiaryInformationId:
      state.BeneficiaryInformation.aI_BeneficiaryInformationId,
  });
  //to add coApplication Names to table
  const addCoApplicantNames = async (e) => {
    const validate = await dispatch(
      ValidateAI_Co_ApplicantNames({
        gender: CoApplicantNamesData.gender,
        phoneNumber: CoApplicantNamesData.phoneNumber,
        emailAddress: CoApplicantNamesData.emailAddress,
        proofOfIdentityDocument: CoApplicantNamesData.proofOfIdentityDocument,
        commissioner: CoApplicantNamesData.commissioner,
        fourSyllablesName: CoApplicantNamesData.fourSyllablesName,
      })
    );
    //if validat ends add row to table
    if (validate.payload.length == 0) {
      //   await AddCoApplicantNames({
      //     gender: CoApplicantNamesData.gender,
      //     phoneNumber: CoApplicantNamesData.phoneNumber,
      //     emailAddress: CoApplicantNamesData.emailAddress,
      //     proofOfIdentityDocument: CoApplicantNamesData.proofOfIdentityDocument,
      //     commissioner: CoApplicantNamesData.commissioner,
      //     fourSyllablesName: CoApplicantNamesData.fourSyllablesName,
      //     aI_BeneficiaryInformationId:
      //       CoApplicantNamesData.aI_BeneficiaryInformationId,
      //   });
      //   $(".close-btn").trigger("click");

      //   dispatch(setRefreshTable());

      await axios
        .post(
          `${dataJsonObject.domainUrl}/api/AI_Co_ApplicantNames/AddAI_Co_ApplicantNames`,
          {
            file: proofOfIdentityDocument,
            fileName: "CoApplicantNames",
            gender: CoApplicantNamesData.gender,
            phoneNumber: CoApplicantNamesData.phoneNumber,
            emailAddress: CoApplicantNamesData.emailAddress,
            proofOfIdentityDocument:
              CoApplicantNamesData.proofOfIdentityDocument,
            commissioner: CoApplicantNamesData.commissioner,
            fourSyllablesName: CoApplicantNamesData.fourSyllablesName,
            aI_BeneficiaryInformationId:
              CoApplicantNamesData.aI_BeneficiaryInformationId,
            aI_ApplicationInformationId: localStorage.getItem(
              "aI_ApplicationInformationId"
            ),
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          //console.log(res);
          $(".close-btn").trigger("click");
          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم اضافة المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });
//to refresh table after action
          dispatch(setRefreshTable());
        })
        .catch((err) => {
          //console.log(err);
        });
    }
  };

  useEffect(() => {
    dispatch(restI_Co_ApplicantNamesDataValidate());
  }, []);
//to update on one row on table CoApplicantNames
  const UpdateCoApplicantNamesData = async () => {
    const validate = await dispatch(
      ValidateAI_Co_ApplicantNames({
        gender: CoApplicantNamesData.gender,
        phoneNumber: CoApplicantNamesData.phoneNumber,
        emailAddress: CoApplicantNamesData.emailAddress,
        proofOfIdentityDocument: CoApplicantNamesData.proofOfIdentityDocument,
        commissioner: CoApplicantNamesData.commissioner,
        fourSyllablesName: CoApplicantNamesData.fourSyllablesName,
      })
    );
    //if validat ends update row on table

    if (validate.payload.length == 0) {
      //   await UpdateCoApplicantNames({
      //     aI_Co_applicantNamesId: props.aI_Co_applicantNamesId,
      //     gender: CoApplicantNamesData.gender,
      //     phoneNumber: CoApplicantNamesData.phoneNumber,
      //     emailAddress: CoApplicantNamesData.emailAddress,
      //     proofOfIdentityDocument: CoApplicantNamesData.proofOfIdentityDocument,
      //     commissioner: CoApplicantNamesData.commissioner,
      //     fourSyllablesName: CoApplicantNamesData.fourSyllablesName,
      //     aI_BeneficiaryInformationId:
      //       CoApplicantNamesData.aI_BeneficiaryInformationId,
      //   });
      //   $(".close-btn").trigger("click");

      //   dispatch(setRefreshTable());

      axios
        .post(
          `${dataJsonObject.domainUrl}/api/AI_Co_ApplicantNames/UpdateAI_Co_ApplicantNamesData`,
          {
            file: fileChange > 0 ? proofOfIdentityDocument : null,
            fileName: fileChange > 0 ? "CoApplicantNames" : null,
            // file: proofOfIdentityDocument,
            // fileName: "CoApplicantNames",
            aI_Co_applicantNamesId: props.aI_Co_applicantNamesId,
            gender: CoApplicantNamesData.gender,
            phoneNumber: CoApplicantNamesData.phoneNumber,
            emailAddress: CoApplicantNamesData.emailAddress,
            proofOfIdentityDocument:
              CoApplicantNamesData.proofOfIdentityDocument,
            commissioner: CoApplicantNamesData.commissioner,
            fourSyllablesName: CoApplicantNamesData.fourSyllablesName,
            aI_BeneficiaryInformationId:
              CoApplicantNamesData.aI_BeneficiaryInformationId,
            aI_ApplicationInformationId: localStorage.getItem(
              "aI_ApplicationInformationId"
            ),
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          //console.log(res);
          $(".close-btn").trigger("click");
          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم تعديل المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });

          dispatch(setRefreshTable());
        })
        .catch((err) => {
          //console.log(err);
        });
    }
  };
  //console.log(
  //   props.BtnClick,
  //   " props.BtnClick",
  //   state.AI_Co_ApplicantNamesData
  // );

  useEffect(() => {
    // This effect runs whenever `props.aI_Co_applicantNamesId` changes.
    // If `props` is not null, dispatch an action to get co-applicant names data using the provided ID.
    if (props != null) {
      dispatch(GetAI_Co_ApplicantNamesData(props.aI_Co_applicantNamesId));
    }
  }, [props.aI_Co_applicantNamesId]);
  // Dependency array: Runs whenever `props.aI_Co_applicantNamesId` changes.
  
  useEffect(() => {
    // This effect runs when `state.AI_Co_ApplicantNamesData` changes.
    if (
      !state.loadingAI_Co_ApplicantNamesData && // Check if the data is not still loading.
      props.BtnClick == "edit" // Proceed only if the button click action is "edit".
    ) {
      // Update the state with the co-applicant names data from the state.
      setCoApplicantNamesData({
        ...state.AI_Co_ApplicantNamesData,
      });
  
      // Compare the email address of the personal information with the co-applicant's email address.
      if (
        state.PersonalInformation.emailAddress == state.AI_Co_ApplicantNamesData?.emailAddress
      ) {
        // If the email addresses are the same, disable editing (set `disabled` to true).
        setDisabled(true);
      } else {
        // If the email addresses are different, allow editing (set `disabled` to false).
        setDisabled(false);
      }
    }
  }, [state.AI_Co_ApplicantNamesData]);
  // Dependency array: Runs whenever `state.AI_Co_ApplicantNamesData` changes.
  
  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  //after loding ends render html
  return (
    <>
      {!state.loadingAI_Co_ApplicantNamesData ? (
        <>
          <div className="AddEditeSubSectorsPage">
            <AllDropDownsAHSF
              fieldsName="Commissioner"
              yesNo={true}
              show={true}
              //   disabled={false}
              dropdownType="normal"
              arrayOoptionList={[
                { text: "نعم", value: true },
                { text: "لا", value: false },
              ]}
              KeyText={"text"}
              KeyValue={"value"}
              defaultValue={state.AI_Co_ApplicantNamesData?.commissioner}
              onChange={(e) => {
                setCoApplicantNamesData({
                  ...CoApplicantNamesData,
                  commissioner: JSON.parse(e.target.value), // التحديث هنا
                });
              }}
              showValidationMessage={
                state.AI_Co_ApplicantNamesValidate
                  ? state.AI_Co_ApplicantNamesValidate.includes("Commissioner")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
              disabled={disabled || shouldDisableFields}
            />
            <InputAHSF
              fieldsName="fourSyllablesName"
              show={true}
              //   disabled={false}
              // showValidationMessage={true}
              // validationMessage="يرجى تعبئة هذا الحقل"
              defaultValue={state.AI_Co_ApplicantNamesData?.fourSyllablesName}
              //   value={state.AI_Co_ApplicantNamesData?.fourSyllablesName}
              onChange={(e) => {
                setCoApplicantNamesData({
                  ...CoApplicantNamesData,
                  fourSyllablesName: e.target.value, // التحديث هنا
                });
              }}
              showValidationMessage={
                state.AI_Co_ApplicantNamesValidate
                  ? state.AI_Co_ApplicantNamesValidate.includes(
                      "fourSyllablesName"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
              disabled={disabled || shouldDisableFields}
            />

            <AllDropDownsAHSF
              fieldsName="Co_ApplicantNames_Gender"
              yesNo={true}
              show={true}
              //   disabled={false}
              disabled={disabled || shouldDisableFields}
              dropdownType="normal"
              arrayOoptionList={[
                { text: "ذكر", value: true },
                { text: "انثى", value: false },
              ]}
              KeyText={"text"}
              KeyValue={"value"}
              defaultValue={state.AI_Co_ApplicantNamesData?.gender}
              onChange={(e) => {
                setCoApplicantNamesData({
                  ...CoApplicantNamesData,
                  gender: JSON.parse(e.target.value), // التحديث هنا
                });
              }}
              showValidationMessage={
                state.AI_Co_ApplicantNamesValidate
                  ? state.AI_Co_ApplicantNamesValidate.includes(
                      "Co_ApplicantNames_Gender"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <InputAHSF
              fieldsName="Co_ApplicantNames_PhoneNumber"
              show={true}
              type={"number"}
              disabled={disabled || shouldDisableFields}
              defaultValue={state.AI_Co_ApplicantNamesData?.phoneNumber}
              onChange={(e) => {
                setCoApplicantNamesData({
                  ...CoApplicantNamesData,
                  phoneNumber: e.target.value, // التحديث هنا
                });
              }}
              showValidationMessage={
                state.AI_Co_ApplicantNamesValidate
                  ? state.AI_Co_ApplicantNamesValidate.includes(
                      "Co_ApplicantNames_PhoneNumber"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
              // showValidationMessage={true}
              // validationMessage="يرجى تعبئة هذا الحقل"
              //   value={state.AI_Co_ApplicantNamesData}
            />
            <InputAHSF
              fieldsName="Co_ApplicantNames_email"
              show={true}
              type={"email"}
              disabled={disabled || shouldDisableFields}
              defaultValue={state.AI_Co_ApplicantNamesData?.emailAddress}
              onChange={(e) => {
                setCoApplicantNamesData({
                  ...CoApplicantNamesData,
                  emailAddress: e.target.value, // التحديث هنا
                });
              }}
              showValidationMessage={
                state.AI_Co_ApplicantNamesValidate
                  ? state.AI_Co_ApplicantNamesValidate.includes(
                      "Co_ApplicantNames_email"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
              // showValidationMessage={true}
              // validationMessage="يرجى تعبئة هذا الحقل"
              //   value={state.AI_Co_ApplicantNamesData}
            />
            <div style={{ marginTop: "10px" }}>
              <label className="labeInput">
                مرفق وثيقة اثبات الشخصية
                <span className="star">*</span>
              </label>
              <div style={{ marginTop: "20px" }}>
                <AttachmentASFH
                  id={"hhhh"}
                  text={"انقر لتعديل المرفق"}
                  title={"إضافة مرفق"}
                  disabled={shouldDisableFields}
                  show={shouldDisableFields ? false : true}
                  clear={false}
                  AttachementType="CoApplicantNames"
                  singleFile={
                    state.AI_Co_ApplicantNamesData?.proofOfIdentityDocument
                  }
                  readOnly={false}
                  onChange={(e) => {
                    setFileChange(fileChange + 1);
                    setproofOfIdentityDocument(e.target.files[0]);

                    setCoApplicantNamesData({
                      ...CoApplicantNamesData,
                      proofOfIdentityDocument: e.target.value, // التحديث هنا
                    });
                  }}
                  validationMessage="يرجى تعبئة هذا الحقل"
                  showValidationMessage={
                    state.AI_Co_ApplicantNamesValidate
                      ? state.AI_Co_ApplicantNamesValidate.includes(
                          "ProofOfIdentityDocument"
                        )
                      : false
                  }
                />
              </div>
            </div>
            {!shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.BtnClick == "edit"
                        ? UpdateCoApplicantNamesData()
                        : addCoApplicantNames();
                    }}
                    disabled={false}
                    title={props.BtnClick == "edit" ? "تعديل" : "اضافة"}
                    text={props.BtnClick == "edit" ? "تعديل" : "اضافة"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            {/* <LoaderAHSF
        show={
          state.SubSectors.loadingaI_SecondarySectors ||
          state.dropDownApplicationInformationLoding.loadingSubSector
        }
      /> */}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingAI_Co_ApplicantNamesData} />
    </>
  );
};

export default AddEdite_CoApplicantNames;
